/**
 * @file getHigherAppPointSum.ts
 * Exports a method to find some of higher app point.
 */

import { AppState } from '../types';

/**
 * Helper method that returns higher app point for the assessment to determine higher price.
 * @returns {number}
 *
 * @param {AppState} appState
 * The application state store.
 */

export default (appState: AppState): number => {
  const { higherAppPoint } = appState.appData.appPoints;
  const totalHigherAppPoint = Object.values(higherAppPoint).reduce(
    (a, b) => a + b,
    0,
  );
  return totalHigherAppPoint;
};
